import {AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild,} from '@angular/core';
import {InscriptionAcheteurService} from '../../inscription-acheteur.service';
import {FormControl, FormGroup} from '@angular/forms';
import {Acheteur} from '../../../../../domain/acheteur/acheteur';
import {CommmCode} from '../../../../../utils/constante/CommonCode';
import {
    SelectAcheteurPublicComponent
} from '../../../../../modules/widget/components/form/select/select-acheteur-public/select-acheteur-public.component';
import {CustomValidators} from '../../../../../forms/validators';
import {AcheteurService} from '../../../../../modules/services/acheteur/acheteur.service';
import {AppTranslateService} from '../../../../../modules/services/translate/app-translate.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-add-info-generale-acheteur',
    templateUrl: './add-info-generale-acheteur.component.html',
    styleUrls: ['./add-info-generale-acheteur.component.css'],
})
export class AddInfoGeneraleAcheteurComponent
    implements OnInit, AfterContentChecked, AfterViewInit {
    @Output() add = new EventEmitter<any>();
    commmCode = CommmCode;
    disables = true;
    intValue: String = 'N';
    @ViewChild(SelectAcheteurPublicComponent) selectAcheteurPublicComponent;
    form: FormGroup;

    constructor(
        private formservice: InscriptionAcheteurService,
        private service: AcheteurService,
        private cdref: ChangeDetectorRef,
        private translateService: AppTranslateService,
        private ranslateService: TranslateService
    ) {
        this.form = this.formservice.addinfoGeneralAcheteur();
        this.ranslateService.onLangChange.subscribe((event: LangChangeEvent) => {
            if (event.lang == 'ar') {
                this.form.get('instNmAr').setValue(null);
                this.form.get('instNm').setValue(null);
                this.form.get('instNmEn').setValue(null);
                this.form.get('instNmAbbrAr').setValue(null);
                this.form.get('instNmAbbrEn').setValue(null);
                this.form.get('instNmAbbr').setValue(null);
                this.form.get('instNmAr').enable();
                this.form.get('instNm').disable();
                this.form.get('instNmEn').disable();
                this.selectAcheteurPublicComponent.ar = true;
                this.selectAcheteurPublicComponent.control.updateValueAndValidity();
                this.form.updateValueAndValidity();
            } else if (event.lang == 'fr') {
                this.form.get('instNmAr').setValue(null);
                this.form.get('instNm').setValue(null);
                this.form.get('instNmEn').setValue(null);
                this.form.get('instNmAbbrAr').setValue(null);
                this.form.get('instNmAbbrEn').setValue(null);
                this.form.get('instNmAbbr').setValue(null);
                this.form.get('instNm').enable();
                this.form.get('instNmAr').disable();
                this.form.get('instNmEn').disable();
                this.form.updateValueAndValidity();
                this.selectAcheteurPublicComponent.fr = true;
                this.selectAcheteurPublicComponent.control.updateValueAndValidity();
            } else if (event.lang == 'en') {
                this.form.get('instNmAr').setValue(null);
                this.form.get('instNm').setValue(null);
                this.form.get('instNmEn').setValue(null);
                this.form.get('instNmAbbrAr').setValue(null);
                this.form.get('instNmAbbrEn').setValue(null);
                this.form.get('instNmAbbr').setValue(null);

                this.form.get('instNmEn').enable();
                this.form.get('instNm').disable();
                this.form.get('instNmAr').disable();
                this.form.updateValueAndValidity();
            }
        });
    }

    ngOnInit(): void {
    }

    get(key: keyof Acheteur) {
        return this.form.get(key) as FormControl;
    }

    getlang() {
        return this.translateService.getDefaultLang();
    }

    next() {
        this.form.get('postCd').enable();
        this.form.get('addr1').enable();
        this.add.emit(this.form.value);
        this.form.get('postCd').disable();
        this.form.get('addr1').disable();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngAfterViewInit(): void {
    }

    getobject(value: any) {

        this.form.get('instRegNo').setValue(value.instCd);
        if (this.getlang() == 'fr') {
            this.form
                .get('instNm')
                .setAsyncValidators(
                    CustomValidators.saveachteurvalidator(value.instCd, this.service)
                );

            console.log('foem', this.form.get('instNm'));
            setTimeout((x) => {
                if (this.form.get('instNm').valid) {
                    this.form.get('instNmAr').setValue(value.instNmAr.trim());
                    this.form.get('instNmEn').setValue(value.instNmEn.trim());
                    this.form.get('instNmAbbrAr').setValue(value.instNmAbbrAr?.trim());
                    this.form.get('instNmAbbrEn').setValue(value.instNmAbbrEn?.trim());
                    this.form.get('instNmAbbr').setValue(value.instNmAbbr?.trim());
                }
            }, 1000);
        } else if (this.getlang() == 'ar') {
            this.form
                .get('instNmAr')
                .setAsyncValidators(
                    CustomValidators.saveachteurvalidator(value.instCd, this.service)
                );
            setTimeout((x) => {
                if (this.form.get('instNmAr').valid) {
                    this.form.get('instNm').setValue(value.instNm.trim());
                    this.form.get('instNmEn').setValue(value.instNmEn.trim());
                    this.form.get('instNmAbbrAr').setValue(value.instNmAbbrAr?.trim());
                    this.form.get('instNmAbbrEn').setValue(value.instNmAbbrEn?.trim());
                    this.form.get('instNmAbbr').setValue(value.instNmAbbr?.trim());
                }
            }, 1000);
        } else if (this.getlang() == 'en') {
            this.form
                .get('instNmEn')
                .setAsyncValidators(
                    CustomValidators.saveachteurvalidator(value.instCd, this.service)
                );
            setTimeout((x) => {
                if (this.form.get('instNmEn').valid) {
                    this.form.get('instNmAr').setValue(value.instNmAr.trim());
                    this.form.get('instNm').setValue(value.instNm.trim());
                    this.form.get('instNmAbbrAr').setValue(value.instNmAbbrAr?.trim());
                    this.form.get('instNmAbbrEn').setValue(value.instNmAbbrEn?.trim());
                    this.form.get('instNmAbbr').setValue(value.instNmAbbr?.trim());
                }
            }, 1000);
        }
    }
}
